/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type { MultiplexRfq, MultiplexRfqInterface } from "../MultiplexRfq";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "orderHash",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "address",
        name: "maker",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint64",
        name: "expiry",
        type: "uint64",
      },
    ],
    name: "ExpiredRfqOrder",
    type: "event",
  },
  {
    inputs: [],
    name: "EIP712_DOMAIN_SEPARATOR",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

export class MultiplexRfq__factory {
  static readonly abi = _abi;
  static createInterface(): MultiplexRfqInterface {
    return new utils.Interface(_abi) as MultiplexRfqInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): MultiplexRfq {
    return new Contract(address, _abi, signerOrProvider) as MultiplexRfq;
  }
}
